import { Link } from 'react-router-dom';
import { Container } from '../components/layout/Primitives';

export default function SizeGuide() {
  return (
    <Container style={{ padding: 'clamp(3rem,8vw,5rem) 1.5rem', maxWidth: '42rem' }}>
      <p className="font-mono-luxe" style={{ fontSize: 11, opacity: 0.55 }}>
        Client care
      </p>
      <h1 className="font-display" style={{ fontSize: 'clamp(2rem, 3vw + 1rem, 3rem)', fontWeight: 300 }}>
        Size guide
      </h1>
      <p style={{ lineHeight: 1.7, opacity: 0.75, marginTop: '1.25rem' }}>
        Standard ready-to-wear measurements will be published here. Until the storefront API is
        connected, use this page as the destination for PDP size-guide links — replace with CMS or
        server-driven tables when integrations go live.
      </p>
      <p style={{ marginTop: '1.5rem' }}>
        <Link to="/contact" style={{ textDecoration: 'underline' }}>
          Contact us
        </Link>{' '}
        for personal fitting advice.
      </p>
      <Link to="/shop/all" style={{ display: 'inline-block', marginTop: '2rem', fontSize: '0.875rem' }}>
        ← Continue shopping
      </Link>
    </Container>
  );
}
